import { FormGroupDirective, NgControl, NgForm, UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class AutocompleteErrorMatcher implements ErrorStateMatcher {
  constructor(private parent: NgControl) {}

  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const parentCtrl = this.parent.control;

    return !!(
      parentCtrl &&
      parentCtrl.invalid &&
      (parentCtrl.touched || parentCtrl.dirty || control?.touched || form?.submitted)
    );
  }
}
